import { Component, OnInit } from '@angular/core';
import { ClinicService } from 'src/app/_services/clinic.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-credit-view',
  templateUrl: './credit-view.component.html',
  styleUrls: ['./credit-view.component.scss'],
})
export class CreditViewComponent implements OnInit {
  clinicCreditInfo: any;
  loading: boolean = true;
  errorMessage: string = '';

  constructor(
    private clinicService: ClinicService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadClinicCredit();
  }

  loadClinicCredit() {
    this.loading = true;
    this.errorMessage = '';
    
    this.clinicService.getAssignedClinics().subscribe({
      next: (clinics: any) => {
        if (clinics.body.data && clinics.body.data.length > 0) {
          this.clinicService
            .getCinicCredit(clinics.body.data[0].id)
            .subscribe({
              next: (res: any) => {
                console.log('Credit Info:', res);
                this.clinicCreditInfo = res.body;
                this.loading = false;
              },
              error: (error) => {
                console.error('Error loading credit info:', error);
                this.errorMessage = 'Failed to load credit information. Please try again.';
                this.loading = false;
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Failed to load credit information',
                });
              }
            });
        } else {
          this.errorMessage = 'No clinics assigned. Please contact your administrator.';
          this.loading = false;
        }
      },
      error: (error) => {
        console.error('Error loading clinics:', error);
        this.errorMessage = 'Failed to load clinic information. Please try again.';
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load clinic information',
        });
      }
    });
  }

  getCreditUsagePercentage(): number {
    if (!this.clinicCreditInfo || this.clinicCreditInfo.limit_amount === 0) {
      return 0;
    }
    return (this.clinicCreditInfo.used_amount / this.clinicCreditInfo.limit_amount) * 100;
  }

  getFormattedCycleMonth(): string {
    if (!this.clinicCreditInfo || !this.clinicCreditInfo.cycle_month) {
      return 'N/A';
    }
    
    try {
      const date = new Date(this.clinicCreditInfo.cycle_month);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long'
      });
    } catch (error) {
      return 'Invalid Date';
    }
  }
}
